import React from "react";
import { Localize } from "components/service";
import { getStaffAuditResult } from "../helpers/staff-audit-log-presentation-helper";


const StaffAuditResultField = ({ status }) => {
    const safeResult = getStaffAuditResult(status);

    return (
        <span className={ `staff-audit-result staff-audit-result--${ safeResult }` }>
            <Localize>{ `STAFF_MANAGEMENT.AuditResult_${ safeResult }` }</Localize>
        </span>
    );
};

export default StaffAuditResultField;
